import type { EffectCallback } from 'react';
import { useEffect } from 'react';

function useEffectOnce(effect: EffectCallback) {
  useEffect(effect, [effect]);
}

export default useEffectOnce;
